<template>
  <section class="block-cars">
    <Car v-for="car in cars" :key="car.id" :data="car" @getCall="() => getCall('sale')" @getFullSlider="(data) => getFullSlider(data)" />
  </section>
</template>

<script>
import Mixin from "../../common/mixin";
import Car from "./car.vue";
import cars from "../../common/cars-info.js";

export default {
  name: "block-cars",
  mixins: [Mixin],
  components: { Car },
  data() {
    return {
      cars,
    };
  },
};
</script>

<style scoped lang="scss">
@import "../../styles/constants.scss";

.block-cars {
  display: flex;
  flex-direction: column;
  gap: 75px;
  width: 100%;
}
</style>
